import { service } from '../../../../helpers/http' 

export const ActionGetCustomerContractStatuses = ({ dispatch }, payload) => { 
    return service({
        module: 'customerContractStatus',
        action: 'getCustomerContractStatuses',
        payload: payload
    })
}
